/**
 * Dental coverage skeleton
 */

import {
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getDentalSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.DENTAL,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "",
      name: "",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.PPO,
      policyPeriod: "newBusiness",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        serviceWaitingPeriods: [],
        dependentAgeLimitYears: 0,
        employerContribution: undefined,
        outOfNetworkReimbursement: undefined,
        maximumRollover: undefined,
        missingToothExclusion: undefined,
        annualOpenEnrollment: undefined,
        deductibleDuration: undefined,
        isDeductibleWaivedPreventative: undefined,
        networkBenefits: [],
        benefitDetails: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
